import { Injectable } from '@angular/core';
import {Observable, of, Subject} from 'rxjs';
import { User } from 'global-nav';
import { ResourceService } from 'src/app/core/service/resource.service';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly userEmitter = new Subject<User>();
  id: string;

  constructor(private resourceService: ResourceService<any>) {
  }

  getUser(): Observable<User> {
    return this.resourceService.get('user/details')
      .pipe( map((user: User) => {
        this.id = user.id;
        return user;
      }));
  }
}
